import React, { useEffect, useMemo } from 'react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import EventsSeminars from '../components/EventsSeminars'
import SEO from '../components/SEO'

const EventsSeminarsPage: React.FC = () => {
  const { t } = useTranslation()

  // Scroll to top when component mounts (instant for navigation)
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // Get events data for structured data
  const eventsRaw = t('events.eventsList', { returnObjects: true })
  const events = Array.isArray(eventsRaw) ? eventsRaw as any[] : []

  // Generate Event structured data
  const eventsStructuredData = useMemo(() => {
    if (events.length === 0) return undefined

    return {
      "@context": "https://schema.org",
      "@graph": events.map((event: any) => ({
        "@type": "Event",
        "name": event.title,
        "description": event.fullDescription || event.description,
        "startDate": event.date,
        "eventStatus": "https://schema.org/EventScheduled",
        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
        "location": {
          "@type": "Place",
          "name": event.location,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": event.location.includes("Mexico City") ? "Mexico City" : event.location,
            "addressRegion": "CDMX",
            "addressCountry": "MX"
          }
        },
        "image": event.image ? `https://logicloud.mx${event.image}` : "https://logicloud.mx/logo.png",
        "organizer": {
          "@type": "Organization",
          "name": event.organizer || "LogiCloud Mexico",
          "url": "https://logicloud.mx"
        },
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "MXN",
          "availability": "https://schema.org/InStock"
        },
        "audience": {
          "@type": "Audience",
          "audienceType": event.attendees || "Tech Community"
        },
        "eventSchedule": {
          "@type": "Schedule",
          "startDate": event.date
        },
        "performer": {
          "@type": "Organization",
          "name": "LogiCloud Mexico"
        }
      }))
    }
  }, [events])

  return (
    <>
      {/* Enhanced SEO for Events & Seminars Page */}
      <SEO 
        url="https://logicloud.mx/events-seminars" 
        type="website"
        image="https://logicloud.mx/events/tec-2025/img-1.jpeg"
        structuredData={eventsStructuredData || undefined}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <EventsSeminars />
      </motion.div>
    </>
  )
}

export default EventsSeminarsPage

